import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

/**
 * Heuristic: does this value look like a date string we know how to sort?
 * Matches ISO dates/timestamps, the European `DD.MM.YYYY, HH:mm` format, or
 * anything dayjs can otherwise parse.
 */
export const isDateString = (value: unknown): boolean => {
  if (typeof value !== 'string' || !value || value === 'N/A') return false

  const isoDatePattern = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?(Z|[+-]\d{2}:\d{2})?)?$/
  if (isoDatePattern.test(value)) return true

  const europeanDatePattern = /^\d{1,2}\.\d{1,2}\.\d{4}, \d{1,2}:\d{2}$/
  if (europeanDatePattern.test(value)) return true

  return dayjs(value).isValid()
}

/**
 * Parses a date string to a timestamp for comparison using dayjs.
 * Returns null if the value is not a valid date.
 */
export const parseDateValue = (value: unknown): number | null => {
  if (value === null || value === undefined || value === 'N/A') return null
  if (typeof value === 'string') {
    let date = dayjs(value)
    if (date.isValid()) return date.valueOf()

    date = dayjs(value, 'DD.MM.YYYY, HH:mm', true)
    if (date.isValid()) return date.valueOf()

    date = dayjs(value)
    return date.isValid() ? date.valueOf() : null
  }
  return null
}
